import { Spin, TreeSelect } from 'antd';
import { Column } from '@ant-design/plots';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import IconEmpty from '../../assets/Images/icons/empty';
import RiskAssessmentService from '../../services/RiskAssessment.service';

export default function Dashboard3({ mDepartment, isLoading }) {
    const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const [selectedConsentValues, setSelectedConsentValues] = useState([]);
    const [departmentActivityRisk, setDepartmentActivityRisk] = useState([]);

    useEffect(() => {
        let defaultSelected = [];
        mDepartment.forEach((element) => {
            defaultSelected.push(element.departmentId);
        });
        setSelectedConsentValues([...defaultSelected]);
    }, [mDepartment, lang]);

    const mvalues = mDepartment?.map((x) => {
        return {
            title: lang === 'en' ? x.nameEn : x.nameTh,
            value: x.departmentId,
        };
    });

    const allConsentIds = mvalues.map(({ value }) => value);

    useEffect(() => {
        if (selectedConsentValues?.length > 0) {
            getDepartmentActivityRisk();
        }
    }, [selectedConsentValues, lang]);

    const getDepartmentActivityRisk = async () => {
        const departmentIds = selectedConsentValues.toString();
        try {
            const { data } =
                await RiskAssessmentService.getDepartmentActivityRisk({
                    departmentIds: departmentIds,
                });
            if (data?.resultData) {
                setdataConfig(data.resultData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const setdataConfig = (dataList) => {
        let listItem = [];
        dataList?.forEach((e) => {
            const item1 = {
                type: t('DashBoardRM.AllActivitiesOfTheDepartment'),
                departmentEn: e.departmentNameEn,
                departmentTh: e.departmentNameTh,
                value: e.totalActivity,
            };

            const item2 = {
                type: t('DashBoardRM.RiskActivities'),
                departmentEn: e.departmentNameEn,
                departmentTh: e.departmentNameTh,
                value: e.totalActivityRisk,
            };

            listItem.push(item1);
            listItem.push(item2);
        });
        setDepartmentActivityRisk(...[listItem]);
    };

    const config = useMemo(() => {
        return {
            data: departmentActivityRisk,
            isGroup: true,
            xField: lang === 'en' ? 'departmentEn' : 'departmentTh',
            yField: 'value',
            seriesField: 'type',
            columnStyle: {
                radius: [20, 20, 0, 0],
            },
            color: ({ type }) => {
                if (type === t('DashBoardRM.RiskActivities')) {
                    return '#F0536F';
                }

                return '#4DBAFF';
            },
            label: {
                position: 'top',
                offset: 8,
                style: {
                    // fill: '#4DBAFF',
                    fontWeight: '600',
                },
            },
            minColumnWidth: 20,
            maxColumnWidth: 20,
            xAxis: {
                label: {
                    autoHide: true,
                    autoRotate: false,
                },
            },
            legend: {
                layout: 'horizontal',
                position: 'bottom',
                marker: {
                    symbol: 'circle',
                },
            },
            tooltip: {
                customContent: (title, data) => {
                    return (
                        <div className="p-3 text-xs font-semibold">
                            <div className="py-1 flex space-x-4">{title}</div>
                            <div className="grid grid-cols-12 py-1">
                                <div className="col-span-1">
                                    <svg
                                        width="9"
                                        height="9"
                                        viewBox="0 0 9 9"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <circle
                                            cx="4.89844"
                                            cy="4.00903"
                                            r="4"
                                            fill={`${data[0]?.color}`}
                                        />
                                    </svg>
                                </div>
                                <div className="col-span-9">{`${data[0]?.name}`}</div>
                                <div className="col-span-2 text-right">{`${data[0]?.value}`}</div>
                            </div>
                            <div className="grid grid-cols-12 py-1">
                                <div className="col-span-1">
                                    <svg
                                        width="9"
                                        height="9"
                                        viewBox="0 0 9 9"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <circle
                                            cx="4.89844"
                                            cy="4.00903"
                                            r="4"
                                            fill={`${data[1]?.color}`}
                                        />
                                    </svg>
                                </div>
                                <div className="col-span-9">{`${data[1]?.name}`}</div>
                                <div className="col-span-2 text-right">{`${data[1]?.value}`}</div>
                            </div>
                        </div>
                    );
                },
            },
        };
    }, [departmentActivityRisk, lang, t]);

    return (
        <Spin spinning={isLoading}>
            <div className="grid grid-cols-12">
                <div className="col-span-10 pb-4">
                    <div className="font-semibold text-xl">
                        {t('DashBoardRM.ExplainRisky')}
                    </div>
                </div>
                <div className="col-span-2 pb-4">
                    <TreeSelect
                        className="w-full"
                        allowClear={true}
                        treeCheckable={true}
                        showCheckedStrategy={TreeSelect.SHOW_CHILD}
                        placeholder={t('Please select department')}
                        filterTreeNode={(search, item) => {
                            return (
                                String(item?.title)
                                    ?.toLowerCase()
                                    ?.indexOf(search?.toLowerCase()) >= 0
                            );
                        }}
                        dropdownStyle={{ maxHeight: '300px' }}
                        onChange={(ids) => setSelectedConsentValues(ids)}
                        value={selectedConsentValues}
                        maxTagCount={0}
                        maxTagPlaceholder={(omittedValues) =>
                            `+ ${omittedValues?.length} ${t('Departments')} ...`
                        }
                        selectable={true}
                        treeData={[
                            {
                                title:
                                    selectedConsentValues?.length > 0 ? (
                                        <button
                                            type="button"
                                            onClick={() =>
                                                setSelectedConsentValues([])
                                            }
                                            style={{
                                                display: 'inline-block',
                                                color: '#286FBE',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            {t('DIDashBoard.UnselectAll')}
                                        </button>
                                    ) : (
                                        <button
                                            type="button"
                                            onClick={() =>
                                                setSelectedConsentValues(
                                                    allConsentIds
                                                )
                                            }
                                            style={{
                                                display: 'inline-block',
                                                color: '#286FBE',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            {t('DIDashBoard.SelectAll')}
                                        </button>
                                    ),
                                value: 'xxx',
                                disableCheckbox: true,
                                disabled: true,
                                checkable: false,
                            },
                            ...mvalues,
                        ]}
                    />
                </div>

                <div className="col-span-12">
                    {selectedConsentValues?.length > 0 &&
                    departmentActivityRisk?.length > 0 ? (
                        <Column {...config} />
                    ) : (
                        <div className="h-[40vh] flex justify-center items-center">
                            <IconEmpty />
                        </div>
                    )}
                </div>
            </div>
        </Spin>
    );
}
